import "./CleaningCheckList.less";
import React, { useEffect, useState } from 'react';
import { Row, Col, Tabs, Collapse } from 'antd';
import { regularServices, deepServices, moveOutServices, postConstructionServices, excludedServices } from "../CalculatorHome/data"

const { TabPane } = Tabs;
const { Panel } = Collapse;

const servicesMap = {
  regular: regularServices,
  moveInOut: moveOutServices,
  deep: deepServices,
  postConstruction: postConstructionServices,
  excluded: excludedServices,
};

const items = [{
  tabName: 'Regular Cleaning',
  key: 'regular',
}, {
  tabName: 'Move-In/Move-Out Cleaning',
  key: 'moveInOut',
}, {
  tabName: 'Deep Cleaning',
  key: 'deep',
}, {
  tabName: 'Post-Construction Cleaning',
  key: 'postConstruction',
}, {
  tabName: 'Excluded Services',
  key: 'excluded'
}]

const CleaningCheckList = ({ defaultSelected }) => {
  const [selected, setSelected] = useState('regular');

  useEffect(() => {
    setSelected(defaultSelected || 'regular');
  }, [defaultSelected]);

  const callback = (key) => {
    if (!key) {
      return;
    }
    setSelected(key);
  }

  return (
    <Row justify="center" className="checklist">
      <Col xs={22} lg={0}>
        <Collapse accordion activeKey={selected} onChange={callback}>
          {
            items.map(({key, tabName}) => {
              const dataToShow = servicesMap[selected];

              return (
                <Panel header={tabName} key={key}>
                  {
                    dataToShow.map(data => (
                      <Row className='checklist__row' key={data.name}>
                        <Col xs={22} style={{ fontWeight: 'bold' }}>{data.name}</Col>
                        {
                          data.items.map((item, idx) => (
                            <Col key={idx + item} className="checklist__item" xs={22} sm={11} lg={7}>{item}</Col>
                          ))
                        }
                      </Row>
                    ))
                  }
                </Panel>
              )
            })
          }
        </Collapse>
      </Col>

      <Col xs={0} lg={24}>
        <Tabs defaultActiveKey="1" onChange={callback} activeKey={selected} type="card">
        {
          items.map(({key, tabName}) => {
            const dataToShow = servicesMap[selected];
            return (<TabPane tab={tabName} key={key} forceRender={true}>
                <div className='checklist__items-wrapper'>
                  {
                    dataToShow.map(data => (
                      <Row className='checklist__row' key={data.name}>
                        <Col xs={22} lg={24} style={{ fontWeight: 'bold' }}>{data.name}</Col>
                        {
                          data.items.map((item, idx) => (
                            <Col key={idx + item} className="checklist__item" xs={22} sm={11} lg={6}>{item}</Col>
                          ))
                        }
                      </Row>
                    ))
                  }
                </div>
            </TabPane>
          )})
        }
        </Tabs>
      </Col>
    </Row>
  )
}

export default CleaningCheckList;